import React from 'react'

import CoreSimpleTextbox from 'core/simpleTextbox.jsx'


export default class CoreSimpleTextArea extends React.Component {
	render() {
		return (
			<CoreSimpleTextbox
				type="textarea"
				{...this.props}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/_core/simpleTextArea.jsx